import dailyCashAdvance from '@/api/expense/daily-cash-advance'
import moment from 'moment'
import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
	...baseState,
	dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')],
	formViewDatas: []
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_VIEW_MODELS(state, { data, index }) {
		if (!index) {
			state.formViewDatas = data;
		} else {
			split(index, ",").forEach(el => {
				state.formViewDatas[el] = data[el];
			});
		}
	},
	SET_DATE_RANGE(state, date) {
		state.dateRange = date
	},
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				branch_id: context.state.branch_id,
				filter: {
					search: context.state.search,
					date_between: _.join(context.state.dateRange, ',')
				}
			},
			attrubutes
		)
		return dailyCashAdvance.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return dailyCashAdvance.store(data)
	},
	update(context, { id, data }) {
		return dailyCashAdvance.update(id, data)
	},
	destroy(context, { id, data }) {
		return dailyCashAdvance.destroy(id, data)
	},
	toPdf(context, id) {
		return dailyCashAdvance.toPdf(id)
	},
	async getPaymentMethod(context) {
		return await dailyCashAdvance.paymentMethod()
	},
	async getBankProfile(context) {
		return await dailyCashAdvance.bankProfile()
	},
	async getEmployee(context) {
		return await dailyCashAdvance.employee()
	},
	async getCurrency(context) {
		return await dailyCashAdvance.currency()
	},
	async getFormViewModel(context, { params, index }) {
		let response = await dailyCashAdvance.formViewModel({ params: params });
		context.commit("SET_VIEW_MODELS", {
			data: response.data,
			index: index
		});
		return Promise.resolve(response);
	}
}